import React, { useEffect, useState } from "react"
import ClientReportCard from "../../components/ClientReportCard.molecule"
import { CLIENT_CONSUMPTION_PERIOD_TYPE_ENUM } from "../../../../consts/modules/clientReport.consts"
import {
  ValueWithLabelContainer,
  ValueWithLabelTemplate,
} from "../../../../components/layouts/containers/ValueWithLabelElements.container"
import { numberFormatter } from "../../../../utils/numbers.utils"
import { getClientPeriodAverageConsumption } from "../../../../services/clientReport.service"
import { DateTime } from "luxon"
import {
  getAverageConsumptionDataByPeriodType,
  getAverageConsumptionLabels,
  isPeriodInvalid,
} from "../../../../utils/clientReport.utils"

const ClientPeriodAverageConsumption = ({ refresh, selectedPeriod = {} }) => {
  const [data, setData] = useState(
    getAverageConsumptionLabels(
      selectedPeriod?.clientConsumptionPeriodType ||
        CLIENT_CONSUMPTION_PERIOD_TYPE_ENUM.MONTHLY
    )
  )
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchData()
  }, [selectedPeriod, refresh])

  const fetchData = async () => {
    setLoading(true)
    try {
      if (isPeriodInvalid(selectedPeriod)) {
        setData(
          getAverageConsumptionDataByPeriodType({
            clientConsumptionPeriodType:
              selectedPeriod?.clientConsumptionPeriodType,
            data,
          })
        )
        return
      }
      const response = await getClientPeriodAverageConsumption(
        selectedPeriod?.clientId,
        selectedPeriod?.startDate || DateTime.now().toISODate()
      )
      if (!response.success) {
        throw new Error(response.message)
      }
      const averages = getAverageConsumptionDataByPeriodType({
        clientConsumptionPeriodType:
          selectedPeriod?.clientConsumptionPeriodType,
        data: response.result,
      })
      setData(averages || {})
    } catch (error) {
      console.error("Error fetching period consumption summary:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <ClientReportCard
      title={"Consumo promedio"}
      iconClassName="pi pi-hourglass text-3xl"
      className="flex-1 font-cairo flex-shrink-0 w-full"
    >
      <ValueWithLabelContainer>
        <ValueWithLabelTemplate
          label="Histórico"
          value={customAverageConsumptionFormat({
            time: data.historic,
            clientConsumptionPeriodType:
              selectedPeriod?.clientConsumptionPeriodType,
          })}
          loading={loading}
        />
        <ValueWithLabelTemplate
          label={data.secondLabel}
          value={customAverageConsumptionFormat({
            time: data.second,
            clientConsumptionPeriodType:
              selectedPeriod?.clientConsumptionPeriodType,
          })}
          loading={loading}
        />
        <ValueWithLabelTemplate
          label={data.thirdLabel}
          value={customAverageConsumptionFormat({
            time: data.third,
            clientConsumptionPeriodType:
              selectedPeriod?.clientConsumptionPeriodType,
          })}
          loading={loading}
        />
        <ValueWithLabelTemplate
          label={data.fourthLabel}
          value={customAverageConsumptionFormat({
            time: data.fourth,
            clientConsumptionPeriodType:
              selectedPeriod?.clientConsumptionPeriodType,
          })}
          loading={loading}
        />
      </ValueWithLabelContainer>
    </ClientReportCard>
  )
}

const customAverageConsumptionFormat = ({
  time,
  clientConsumptionPeriodType,
}) => {
  if (!time) return "-"
  let periodSuffix = ""
  switch (clientConsumptionPeriodType) {
    case CLIENT_CONSUMPTION_PERIOD_TYPE_ENUM.WEEKLY:
      periodSuffix = "hs/sem"
      break
    case CLIENT_CONSUMPTION_PERIOD_TYPE_ENUM.MONTHLY:
      periodSuffix = "hs/mes"
      break
    case CLIENT_CONSUMPTION_PERIOD_TYPE_ENUM.SPRINT:
      periodSuffix = "hs/sprint"
      break
    default:
      return null
  }
  if (time > 0) {
    return (
      <span className="flex align-items-center gap-1">
        <span className="flex align-items-baseline gap-1">
          <span>{numberFormatter(time, 1)}</span>
          <p className="text-base">{periodSuffix}</p>
        </span>
      </span>
    )
  }
  return <p className="text-base m-0">- {periodSuffix}</p>
}

export default ClientPeriodAverageConsumption
